export const isGameflares =  window.location.hostname.includes('gameflares')
//  || window.location.hostname.includes('localhost')
 ? true : false


 export const isGamiway =  window.location.hostname.includes('gamiway')
//  || window.location.hostname.includes('localhost')
 ? true : false


 export const isGamelords = window.location.hostname.includes("game-lords")
    //  || window.location.hostname.includes('localhost')
    ? true
   : false;


// WEBPACK FOOTER //
// ./src/constants/productCondition.js